import React from "react";
import type {VoidFunctionComponent} from "react";
import s from "./SongDetailsLessonsList.module.scss";
import {useSongDetailsLessonsListLogic} from "./SongDetailsLessonsList.logic";
import {SongDetailsLessonsListGroup} from "../lessons-list-group/SongDetailsLessonsListGroup";
import {isDefined} from "../../../../../../util/is-type";

export interface ISongDetailsLessonsListProps {
  useClassName?: string;
}

export const SongDetailsLessonsList: VoidFunctionComponent<ISongDetailsLessonsListProps> = ({useClassName}) => {
  const {groups, activeLessonId} = useSongDetailsLessonsListLogic();
  const activeClassNames = [
    s.lessonList,
  ];
  if (isDefined(useClassName)) {
    activeClassNames.push(useClassName);
  }
  return (
    <div className={activeClassNames.join(` `)}>
      {groups.map((group) => <SongDetailsLessonsListGroup difficultyCategory={group} key={`song-details-group-${group}`} activeLessonId={activeLessonId} />)}
    </div>
  );
}

